export default "__VITE_ASSET__Dr3ZZDV2__"